documentReady(function($, Lum) {
    console.log('Child Script Loaded.');

    $('.frm_form_field select').each(function(){
        var placeholder_text = $(this).find('option').first().text();
        $(this).select2({
            placeholder: placeholder_text,
            minimumResultsForSearch: -1
        });
    });

    $("#field_phone").each(function(index, elem) {
        Lum.mask("(999) 999-9999", elem);
    });

    $('#field_email').parsley({
        'type' : 'email'
    });

    $('.mobile-nav #menu-main-menu-1 li').children('ul').hide();
    $('.mobile-nav #menu-main-menu-1 li').click(function () {

        if ($(this).children('ul,p').is(':hidden') == true) {
            $(this).children('ul,p').slideDown('slow');
            return false
        }
    })

});
